<template>
  <div
    class="tags-view-container"
    :style="`background-color: ${theme.slideColor}`"
  >
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <div
        class="tag-warp"
        v-for="(tag, index) in visitedViews"
        :key="tag.nodeId"
      >
        <span
          ref="tag"
          :style="`color:${theme.textColor};`"
          :to="tag.meta ? tag.meta.name : tag.name"
          class="tags-view-item"
          @click="changeTag(tag, index)"
          @contextmenu.prevent="openMenu(tag, $event)"
        >
          <!-- <svg-icon v-if="tag.path==='/dashboard'" icon-class="home"/> -->
          {{ tag.path === "/dashboard" ? "" : tag.name || tag.meta.name }}
          <svg-icon
            :style="`margin-top:-5px;color: ${theme.textColor}`"
            v-if="tag.path === '/dashboard'"
            icon-class="home-line"
          />
          <el-dropdown
            v-if="tag.path === '/dashboard'"
            placement="bottom-start"
            @command="handleDecisionClick"
          >
            <span :style="`font-size:12px;color:${theme.textColor}`">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in decisionList"
                :key="item.id"
                :command="item.id"
                >{{ item.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <span
            v-if="isActive(tag, index)"
            class="float-border"
            :style="`background:${theme.textColor};`"
          ></span>
          <span
            v-if="tag.path !== '/dashboard'"
            class="el-icon-close"
            :style="`color:${theme.textColor};`"
            @click.prevent.stop="closeSelectedTag(tag)"
          />
        </span>
      </div>
    </scroll-pane>
    <transition name="el-zoom-in-top">
      <ul
        v-show="visible"
        :style="{ left: left + 'px', top: top + 'px' }"
        class="contextmenu"
      >
        <!-- <li @click="refreshSelectedTag(selectedTag)">{{ $t('tagsView.refresh') }}</li> -->
        <li
          v-if="selectedTag.path !== '/dashboard'"
          @click="closeSelectedTag(selectedTag)"
        >
          {{ $t("tagsView.close") }}
        </li>
        <li @click="closeOthersTags(selectedTag)">
          {{ $t("tagsView.closeOthers") }}
        </li>
        <li @click="closeAllTags">{{ $t("tagsView.closeAll") }}</li>
      </ul>
    </transition>
  </div>
</template>
<script>
import ScrollPane from '@/components/ScrollPane'
import { generateTitle } from '@/utils/i18n'
import { getStrategy } from '@/api/dashboard'
import { mapGetters } from 'vuex'

export default {
  name: 'TagsView',
  components: { ScrollPane },
  data() {
    return {
      activeIndex: null,
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      decisionList: []
    }
  },
  computed: {
    ...mapGetters([
      'userId', 'lastActiveDecision', 'showRefresh', 'refreshing', 'theme'
    ]),
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    prevTab() {
      return this.$store.state.tagsView.prevTab
    },
    lastTab() {
      return this.$store.state.tagsView.lastTab
    }
  },
  watch: {
    '$route': 'moveToCurrentTag',
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    },
    lastTab(newTab, oldTab) {
      const visitedViews = this.$store.state.tagsView.visitedViews
      if (visitedViews.find(v => v.nodeId === oldTab.nodeId)) {
        this.$store.dispatch('SetPrevTab', oldTab)
      } else {
        this.$store.dispatch('SetPrevTab', newTab)
      }
    }
  },
  created() {
    this.getStrategy()
  },
  mounted() {
    this.addViewTags()
  },
  methods: {
    changeTag(tag, index) {
      let url
      if (tag.meta) {
        url = tag.path
        localStorage.removeItem('lastTab')
      } else {
        url = tag.path
      }
      this.$store.dispatch('SetLastTab', tag)

      this.$router.push(url)
      this.moveToCurrentTag()
    },
    generateTitle, // generateTitle by vue-i18n
    isActive(tag, index) {
      if (tag.meta) {
        return tag.path === this.$route.path
      } else {
        if (this.$route.params.model) {
          if (this.$route.params.model === undefined && tag.routeType === 'preview') {
            return tag.id === +this.$route.params.templateId
          } else if (this.$route.params.model === '0' && (tag.routeType === 'check' || tag.routeType === 'create' || tag.routeType === 'query' || tag.routeType === 'createWorkFlow')) {
            return tag.path === this.$route.path
          } else {
            return tag.recordId === +this.$route.params.recordId && tag.model === +this.$route.params.model
          }
        } else {
          return tag.path === this.$route.path
        }
      }
    },
    addViewTags() {
      if (localStorage.getItem('lastTab')) {
        this.$store.dispatch('addView', JSON.parse(localStorage.getItem('lastTab')))
      }
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      let index
      this.visitedViews.forEach((v, i) => {
        v.nodeId === this.$route.params.id ? index = i : ''
      })
      this.$nextTick(() => {
        this.$refs.scrollPane.moveToTarget(tags[index])
      })
    },
    refreshSelectedTag(view) {
      let url
      if (view.meta) {
        url = view.path
        localStorage.removeItem('lastTab')
      } else {
        url = url = view.path
      }
      this.$nextTick(() => {
        this.$router.replace({
          path: url
        })
      })
    },
    closeSelectedTag(view) {
      let latestView
      var handleClose = () => {
        this.visitedViews.forEach((tab, index) => {
          if (tab.path === view.path) {
            console.log(typeof (this.prevTab))
            const nextTab = (this.visitedViews[index + 1] || this.visitedViews[index - 1])
            const prevTab = this.prevTab && this.prevTab.path && this.prevTab.path !== view.path && this.visitedViews.find(v => v.path === this.prevTab.path) ? this.prevTab : undefined
            console.log(prevTab, nextTab)
            if (nextTab) {
              latestView = prevTab || nextTab
              this.$store.dispatch('delView', view).then(({ visitedViews }) => {
                if (this.isActive(view)) {
                  if (latestView.path === '/dashboard') {
                    this.$router.push(latestView.path)
                    localStorage.removeItem('lastTab')
                  } else {
                    const url = latestView.path
                    this.$router.push(url)
                    this.$store.dispatch('SetLastTab', latestView)
                  }
                }
              })
            }
          }
        })
      }
      if (view.routeType && (view.routeType === 'create' || view.routeType === 'edit')) {
        this.$confirm(this.$t('alert.close'), this.$t('status.warning'), {
          confirmButtonText: this.$t('buttons.confirm'),
          cancelButtonText: this.$t('buttons.cancel'),
          type: 'warning'
        }).then(() => {
          handleClose()
        })
      } else {
        handleClose()
      }
    },
    closeOthersTags(view) {
      this.changeTag(view)
      for (var i = this.visitedViews.length - 1; i >= 0; i--) {
        var tab = this.visitedViews[i]
        if (tab.path !== view.path && tab.path !== '/dashboard') {
          this.$store.dispatch('delView', tab)
        }
      }
      this.$store.dispatch('SetPrevTab', view)
    },
    closeAllTags() {
      var tab
      for (var i = this.visitedViews.length - 1; i >= 0; i--) {
        tab = this.visitedViews[i]
        if (tab.path !== '/dashboard') {
          this.$store.dispatch('delView', tab)
        } else {
          this.$router.push(tab.path)
        }
      }
      this.$store.dispatch('SetPrevTab', undefined)
      localStorage.removeItem('lastTab')
    },
    openMenu(tag, e) {
      this.visible = true
      this.selectedTag = tag
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      this.left = e.clientX - offsetLeft + 15 // 15: margin right
      this.top = e.clientY - 48
    },
    closeMenu() {
      this.visible = false
    },
    getStrategy() {
      getStrategy(this.userId).then(response => {
        this.decisionList = response.data.filter(item => { return item && item.frontDisplay })
        if (this.decisionList.length > 0) {
          this.$store.dispatch('setLastActiveDecision', this.decisionList[0].id)
          // if (this.$route.path === '/dashboard') {
          //   this.handleDecisionClick(this.decisionList[0].id)
          // }
        }
        var decisionIdList = []
        this.decisionList.forEach(item => {
          decisionIdList.push(+item.id)
        })
        this.$store.dispatch('setDecisionInHome', decisionIdList)
      })
    },
    handleDecisionClick(decisionId) {
      this.$store.dispatch('setLastActiveDecision', decisionId)
      this.changeTag({ path: '/dashboard', routeType: 'home', meta: { name: '首页', title: 'home' } }, 0)
      // this.$emit('handleDecisionClick', decisionId)
    },
    refreshData() {
      this.$emit('refreshData', true)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.tags-view-container {
  height: 38px;
  width: 100%;
  background: #fff;
  // border-bottom: 1px solid #ebeef5;
  position: relative;
  // .refresh-button{
  //   position: absolute;
  //   top: 0px;
  //   font-size: 20px;
  //   right: 10px;
  // }
  .tags-view-wrapper {
    .is-vertical {
      display: none;
    }
    .tag-warp {
      display: inline-block;
      padding: 0 10px;
      position: relative;
      // &::after{
      //   position: absolute;
      //   right:0;
      //   content: '';
      //   width: 1px;
      //   height: 18px;
      //   top:50%;
      //   margin-top: -9px;
      //   background: #ebeef5;
      // }
    }
    .tag-warp:first-child {
      padding: 0 10px 0 10px;
      .tags-view-item {
        padding-right: 10px;
      }
    }
    .tags-view-item {
      display: inline-block;
      padding: 0 15px 0 10px;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: 100% 50%;
      position: relative;
      cursor: pointer;
      height: 33px;
      line-height: 33px;
      font-size: 12px;
      margin-top: 4px;
      .el-icon-close {
        width: 14px;
        height: 14px;
        vertical-align: 2px;
        right: -2px;
        top: 50%;
        margin-top: -7px;
        border-radius: 50%;
        position: absolute;
        text-align: center;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        transform-origin: 100% 50%;
        cursor: pointer;
        &:before {
          transform: scale(0.6);
          display: inline-block;
          vertical-align: -2px;
        }
        // &:hover {
        //   background-color: #b4bccc;
        //   color: #fff;
        // }
      }
      .float-border {
        height: 2px;
        width: 100%;
        left: 0;
        position: absolute;
        bottom: 0px;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 100;
    position: absolute;
    list-style-type: none;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    padding: 5px 0;
    margin: 5px 0;
    background-color: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    li {
      margin: 0;
      padding: 7px 16px;
      color: #606266;
      cursor: pointer;
      &:hover {
        background-color: #ecf5ff;
        color: #66b1ff;
      }
    }
  }
  .el-dropdown-selfdefine {
    outline: none;
  }
}
</style>


